import { Moon } from "lucide-react";

export const Marquee = ({ items, className = "" }) => (
  <div
    className={`overflow-hidden border-y border-navy/10 py-6 select-none bg-white ${className}`}
    aria-hidden="true"
    data-testid="editorial-marquee"
  >
    <div className="marquee-track flex w-max items-center">
      {[...items, ...items].map((item, i) => (
        <span key={i} className="flex items-center shrink-0">
          <span className="font-display text-2xl sm:text-3xl text-navy/90 italic px-8">
            {item}
          </span>
          <Moon size={13} className="text-gold fill-gold" />
        </span>
      ))}
    </div>
  </div>
);
